import { DetectorMap, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

/**
 * Defines actions that can be performed for the
 * Detector Mappings in the store.
 */
export enum DetectorMapActionTypes {
    AddMaps = 'ADD_MAPS',
    ModifyMaps = 'MODIFY_MAPS',
    DeleteMaps = 'DELETE_MAPS'
}

export interface AddDetectorMaps extends Action {
    type: DetectorMapActionTypes.AddMaps;
    detectorMaps: DetectorMap[];
}

export interface ModifyDetectorMaps extends Action {
    type: DetectorMapActionTypes.ModifyMaps;
    detectorMaps: DetectorMap[];
}

export interface DeleteDetectorMaps extends Action {
    type: DetectorMapActionTypes.DeleteMaps;
    ids: Id[];
}